// extracted by mini-css-extract-plugin
export default {"insightsGrid":"InsightsGrid_insightsGrid__R4-L-","insightsGridItem":"InsightsGrid_insightsGridItem__R5Kcq"};